export const dispatchLoggedInEvent = (bearer: string) => {
  localStorage.setItem("accessToken", bearer);
};

export function dispatchLoggedOutEvent() {
  localStorage.removeItem("accessToken");
}
